import { IonPage, IonContent, IonIcon, IonSpinner } from "@ionic/react";
import { useAppSelector } from "../app/hooks";
import {
  selectWorkerAnswerableQuestionnaires,
  selectWorkerHealthReports,
} from "../features/worker/workerSlice";

import "./Vigilancia.scss";
import Questionnaire from "../components/Questionnaire";
import Report from "../components/Report";
import Advice from "../components/Advice";
import Aptitude from "../components/Aptitude";
import Toolbar from "../components/Toolbar";
import MedicalHistoryDocument from "../components/MedicalHistoryDocument";

import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

import { documentTextOutline, helpCircleOutline, informationCircleOutline } from "ionicons/icons";

const Vigilancia: React.FC = () => {
  const [t] = useTranslation("global");

  const answerableQuestionnaires = useAppSelector(
    selectWorkerAnswerableQuestionnaires,
  );
  const healthReports = useAppSelector(selectWorkerHealthReports);

  const [activeTab, setActiveTab] = useState(0);
  const handleTabClick = ( index : number ) => {
      setActiveTab(index);
  };

  console.log( healthReports )

  interface IVigilanciaColumns {
          title : string
          empty : string
          data  : any[]
          type  : string
      }
  
  interface IVigilanciaTabs {
      name    : string
      name_s  : string
      icon    : string
      columns : IVigilanciaColumns[]
  }
  
  const [vigilanciaTabs, setVigilanciaTabs] = useState<IVigilanciaTabs[]>([]);

  useEffect(() => {
      setVigilanciaTabs([
          {
              name    : t('Informes'),
              name_s  : t('Informe'),
              icon    : documentTextOutline,
              columns : [
                  {
                      title : '',
                      empty : t('No hay Informes'),
                      data  : healthReports,
                      type  : 'report'
                  }
              ]
          },
          {
              name    : t('Cuestionarios sin responder'),
              name_s  : t('Cuestionario sin responder'),
              icon    : helpCircleOutline,
              columns : [
                  {
                      title : '',
                      empty : t('No hay Cuestionarios sin responder'),
                      data  : answerableQuestionnaires,
                      type  : 'questionnaire'
                  }
              ]
          },
          {
              name    : t('Consejos'),
              name_s  : t('Consejo'),
              icon    : informationCircleOutline,
              columns : [
                  {
                      title : '',
                      empty : t('No hay Consejos'),
                      data  : healthReports.filter( report => report.show_advices === 'True' ),
                      type  : 'advice'
                  }
              ]
          },
      ])
  return () => {
  };
  }, [healthReports]);

  const renderColumnContent = (column: IVigilanciaColumns) => {
    if (!column?.data?.length) {
      return (
        <li className="report__file file file--no-hover">
          <p className="file__info">
            <span className="file__type">{ column.empty }</span>
          </p>
        </li>
      );
    }

    switch (column.type) {
      case "report":
        return column.data.map((report, index) => {
          switch (report.file_type) {
            case "aptitude_periods":
              return <Aptitude key={index} rep={report} />;
            case "medical_consultations":
              return <Report key={index} rep={report} />;
            case "medical_history_documents":
              return <MedicalHistoryDocument key={index} rep={report} />;
            default:
              return null;
          }
        });
      case "questionnaire":
        return column.data.map((q, index) => (
          <Questionnaire key={index} rep={q} />
        ));
      case "advice":
        return column.data.map((a, index) => (
          <Advice key={index} adv={a} />
        ));
      default:
        return null;
    }
  };

  return (
    <IonPage>
      <Toolbar title={t("Vigilancia de la Salud")} />
      <IonContent fullscreen>
        <div className="vigil">
          <ul className="tabs">
            { vigilanciaTabs.map((tab, i) => {
                return (
                  <li
                    className={`tabs__li ${i === activeTab ? "active" : ""}`}
                    key={i}
                  >
                    <button
                      onClick={() => handleTabClick(i)}
                      type="button"
                      className="tabs__button"
                    >
                      <IonIcon aria-hidden="true" ios={tab.icon} md={tab.icon} />
                      {tab.name}
                    </button>
                  </li>
                );
              })
            }
          </ul>
          { vigilanciaTabs.map((tab, i) => {
            return (
              <div
                className={`tabs__wrapper ${i === activeTab ? "active" : ""}`}
                key={i}
              >
                {tab.columns &&
                  tab.columns.map((column, index) => (
                    <div className="tabs__body" key={index}>
                      {
                        <div className="tabs__header">
                          <div className="tabs__title">
                            {column.title ? column.title : tab.name} (
                              {column.data ? column.data.length : <IonSpinner name="circles"/>}):
                          </div>
                        </div>
                      }
                      {column.data && (
                        <div className="data-list data-list--double">
                          {renderColumnContent(column)}
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            );
          })}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Vigilancia;
